import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IPartnerFlagsChangeRequestResult } from 'partner360/models/partnerFlagRequests/IPartnerFlagsChangeRequestResult'
import { TFlagChangeRequest } from 'partner360/models/partnerFlagRequests/TFlagChangeRequest'

interface IAddTopPartnerRequestArgs {
  fYear: number
  partnerId: string
  request: TFlagChangeRequest
}
export const addTopPartnerRequest = async ({
  fYear,
  request,
  partnerId,
}: IAddTopPartnerRequestArgs): Promise<IPartnerFlagsChangeRequestResult> => {
  const url = proxy('/webservice/621/sp/v3/spJBPTopPartnerFlagsRequestCreate/call')
  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const payload = {
    'p.PartnerID': partnerId,
    'p.FYear': fYear,
    'p.Request': JSON.stringify(request),
  }

  const response = await Rest.post({ url, payload, headers })

  return response.Rows[0]
}
